<div class="shift-compliance-container">
	<div
		class="
			d-flex
			flex-column flex-lg-row
			justify-content-between
			align-items-center
		"
	>
		<img
			class="shift-compliance-left"
			src="../assets/img/regscale-all.svg"
			alt=""
		/>

		<div class="shift-compliance-right">
			<h1 class="shift-compliance-header">RegScale For All</h1>
			<p class="shift-compliance-para mt-4">
				Embrace simplicity. We deliver straight-forward
				<br class="d-none d-sm-block" />
				subscriptions, no unexpected costs, a cancel
				<br class="d-none d-sm-block" />
				anytime policy, and completely free options for the
				<br class="d-none d-sm-block" />
				budget-constrained.
			</p>
		</div>
	</div>
</div>
